import React from 'react';
import { Heading, Grid, GridColumn } from '@fairygodboss/ui';

export const ContentTitle = ({ communityContext }) => {
    const { contentTitle, isCommunityDiscussionType } = communityContext();
    return (
        <Grid css={{ maxWidth: '100%' }}>
            <GridColumn
                size={{ _: 12, sm: 12, md: 11, lg: 11 }}
                css={{
                    a: {
                        textDecoration: 'none',
                    },
                }}
            >
                <Heading
                    variant={{ _: 'headingLg', md: 'heading2xl' }}
                    as="h1"
                    {...(isCommunityDiscussionType && {
                        itemProp: 'headline',
                    })}
                >
                    {contentTitle}
                </Heading>
            </GridColumn>
        </Grid>
    );
};

ContentTitle.displayName = 'ContentTitle';
